import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Sparkles, History, MessageCircle, Crown, Settings } from 'lucide-react';
import CompanionSettingsDialog from './CompanionSettingsDialog';

const CompanionHeader = ({
  language,
  limits,
  isPremium,
  isLimitReached,
  onToggleHistory,
  onNewConversation,
}) => {
  const [settingsOpen, setSettingsOpen] = useState(false);
  return (
  <div className="bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 px-4 py-3 flex items-center justify-between">
    <div className="flex items-center gap-2">
      <Sparkles className="w-5 h-5 text-purple-600" />
      <h2 className="text-lg font-semibold text-slate-800 dark:text-white">
        {language === 'es' ? 'Compañero Lumera' : 'Lumera Companion'}
      </h2>
    </div>

    <div className="flex items-center gap-2">
      {limits && (
        <div
          className={`text-xs px-3 py-1 rounded-full ${
            isPremium
              ? 'bg-gradient-to-r from-yellow-400 to-orange-400 text-white font-semibold'
              : isLimitReached
                ? 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-200'
                : 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-200'
          }`}
          data-testid="lumera-limits-chip"
        >
          {isPremium ? (
            <span className="flex items-center gap-1">
              <Crown className="w-3 h-3" />
              {language === 'es' ? 'Ilimitado' : 'Unlimited'}
            </span>
          ) : (
            <span>
              {limits.remaining_questions} {language === 'es' ? 'restantes' : 'remaining'}
            </span>
          )}
        </div>
      )}

      <Button
        variant="ghost"
        size="sm"
        onClick={onToggleHistory}
        className="text-slate-600 dark:text-slate-300"
        data-testid="lumera-toggle-history-btn"
      >
        <History className="w-4 h-4" />
      </Button>

      <Button
        variant="ghost"
        size="sm"
        onClick={() => setSettingsOpen(true)}
        className="text-slate-600 dark:text-slate-300"
        data-testid="lumera-settings-btn"
        title={language === 'es' ? 'Preferencias' : 'Preferences'}
      >
        <Settings className="w-4 h-4" />
      </Button>

      <Button
        variant="ghost"
        size="sm"
        onClick={onNewConversation}
        className="text-slate-600 dark:text-slate-300"
        data-testid="lumera-new-conversation-btn"
      >
        <MessageCircle className="w-4 h-4" />
      </Button>
    </div>
    <CompanionSettingsDialog open={settingsOpen} onOpenChange={setSettingsOpen} language={language} />
  </div>
  );
};

export default CompanionHeader;
